export const getLoanRatio = (loanAmount, spendAmount) => {
  return loanAmount / spendAmount
}
